import Cookies from "js-cookie";

const getCorporationModules = () => {
  try {
    return JSON.parse(localStorage.getItem("corporationModules")) || {};
  } catch {
    return {};
  }
};

const getMobileUserEmail = () => {
  const cookieEmail = Cookies.get("userEmail") || "";
  if (cookieEmail) {
    return cookieEmail;
  }

  try {
    const storedUser = JSON.parse(localStorage.getItem("user") || "null");
    return storedUser?.email || "";
  } catch {
    return "";
  }
};

export const isMobileAkanthasAccount = () => {
  return getMobileUserEmail().includes("@akanthas.com");
};

const isMobileAkanthasAdmin = () => {
  const viewMode = Cookies.get("viewMode") || "client";
  return isMobileAkanthasAccount() && viewMode === "admin";
};

export const hasMonitoringModule = () => {
  if (isMobileAkanthasAdmin()) {
    return true;
  }
  const modules = getCorporationModules();
  return Number(modules.showMonitoringModule) > 0;
};

export const hasCharacterizationModule = () => {
  if (isMobileAkanthasAdmin()) {
    return true;
  }
  const modules = getCorporationModules();
  return Boolean(modules.showCharacterizationModule);
};

export const hasPhotoCaptureModule = () => {
  const modules = getCorporationModules();
  // Fallback until the corporation is saved once with the new backoffice flag
  return Boolean(
    modules.showPhotoCaptureModule ?? modules.showCharacterizationModule,
  );
};
